import { Navigate } from "react-router-dom"
import { isPermitted } from "../components/Can"

import { useAppContext } from "../contexts/AppProvider"

const Admin = () => {
  const { user } = useAppContext()

  if (isPermitted({ user, action: "projectTemplates.view" })) {
    return <Navigate to="/admin/templates" />
  }

  if (isPermitted({ user, action: "commonForms.view" })) {
    return <Navigate to="/admin/common-forms" />
  }

  if (isPermitted({ user, action: "users.view" })) {
    return <Navigate to="/admin/users" />
  }

  return <Navigate to="/" />
}

export default Admin
